import invert from 'lodash/invert'
import languageMap from '~/i18n/languageMap'
const languageToDomain = invert(languageMap)

export default function getSupportedBrowserLanguage() {
  const { language = 'en' } = navigator || {}

  if (typeof languageToDomain[language] !== 'undefined') {
    return language
  }

  const locale = Object.keys(languageToDomain).find(supportedLocale => {
    const supportedLanguage = supportedLocale.split('-')[0]

    return supportedLanguage === language
  })

  if (typeof locale !== 'undefined') {
    return locale
  }

  return 'en'
}
